import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService, UserService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';


import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {Page} from "../models/page";
import {Items} from "../models/items";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute} from "@angular/router";
import {LogService} from "./services/log.service";
import {FirstTimeConfirmationDialogComponent} from "../voucherTemplate/dialog/firstTimeConfirmation.component";
import {DetailsDialogComponent} from "./dialog/details.component";

@Component({
    templateUrl: './log.component.html',
    styleUrls: ['./log.component.scss']
})
export class LogComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    filterValue: string;
    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;
    deleteDialogRef: any;
    from: string;
    to: string;
    firstOnlineSaleFrom: string;
    firstOnlineSaleTo: string;
    firstTraditionalSaleFrom: string;
    locale = 'pl';
    filters: any[];
    sort: any[] = [];
    objectReference: string;
    referenceId: string;
    matDialogRef: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        public _matDialog: MatDialog,
        private route: ActivatedRoute,
        private logService: LogService,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 20;

        this.objectReference = this.route.snapshot.params['objectReference'];
        this.referenceId = this.route.snapshot.params['referenceId'];

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Logs');
    }

    ngOnInit() {
        this.sort['sortDir'] = 'DESC';
        this.sort['sortCol'] = 'createdAt';

        this.setPage({ offset: 0 });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    public unsubscribe(): void {
        this._unsubscribeAll.next();
    }

    sortResults(pageInfo) {
        this.rows = [];
        this.page.totalElements = 0;
        this.loadingIndicator = true;
        this.sort['sortDir'] = pageInfo.sorts[0].dir;
        this.sort['sortCol'] = pageInfo.sorts[0].prop;

        this.setPage({ offset: 0 });
    }

    setPage(pageInfo) {
        this.unsubscribe();
        this.loadingIndicator = true;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.filters = [];
        this.filters['referenceId'] = this.referenceId;
        this.filters['objectReference'] = this.objectReference;

        this.logService.getAllPaged(pageInfo.offset * pageInfo.limit, pageInfo.limit, this.filters, this.sort).pipe(takeUntil(this._unsubscribeAll))
            .subscribe( (res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    openLogDetails(log) {
        this.matDialogRef = this._matDialog.open(DetailsDialogComponent, {
            panelClass: 'details-dialog',
            data: {
                action: 'show',
                log: log
            },
            width: '650px',
        });
    }
}
